// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2zaxL","tab":"Tabs_tab__3UrKw","tabActive":"Tabs_tabActive__3QOev"};